export default "__VITE_ASSET__7917fa9d__"